<template>
  <div class="ui segments">

      <div class="ui segment">
        <div class="ui breadcrumb">
          <router-link :to="{name:'home'}" class="section">Sākums</router-link>
          <span class="divider">/</span>
          <router-link :to="{name:'waiting-for-delivery'}" class="section">Gaida piegādi</router-link>
          <span class="divider">/</span>
          <div class="active section">Rediģēt</div>
        </div>
      </div>

 <div class="ui segment loading">
 &nbsp;

  </div>

</div>

</template>

<script>

export default {

  activated(){
    var id = (this.$route.params.id) ? this.$route.params.id : 0;
    //load only once and if not matching so that page is not related when user goes to add goods page for autoship and change state in autoship form
    
      this.$store.dispatch('loadOrder',id).then((response) => {

          this.goToEditPage(response.data.order)

      }).catch((error) => {
        console.error('Order was not loaded')
        //go back to previous page
        this.$router.push({
            name: 'waiting-for-delivery',
        });

      });

  },

  methods:{

    goToEditPage(item) {

      // process is as follows:
      // order is copied to cart and user will modify cart not order.
      // Once user save data he will update order (if its still possible) and cart will be deleted
      // to prevent clashes with active cart, we will use autoshipCart store for frontend. For future could merge cart/autoship/and this into one
      this.$store.commit('SET_ORDER_ITEMS', [])
      this.$store.commit('SET_ORDER_DETAILS', {})
      this.$store.dispatch('convertOrderToCart',item).then((response) => {

        this.$router.push({
            name: 'waiting-for-delivery-edit',
            params: {
                id: response.data.data.id
            }
        });

      }).catch((error) => {
        console.error(error)
        console.error('Order conversion failed')
      });

    },


  }

}
</script>



// WEBPACK FOOTER //
// WaitingForDeliveryGetEditPage.vue?2dd18794